import { BrandName } from 'common/environment/types';

export type DataEnv = 'local' | 'inkMainnet' | 'inkTestnet';

export interface BaseClientEnv {
  // Determines supported chains to interact with
  dataEnv: DataEnv;
  // Determines app branding
  brandName: BrandName;
  // Enables any WIP / experimental features
  enableExperimentalFeatures: boolean;
  // An identifier for the current build
  buildId: string;
  // Nado builder ID for earning trade commissions (integer, Nado-assigned)
  builderId: number | undefined;
  // Builder fee rate in 0.1 bps units (50 = 5 bps = 0.05%)
  builderFeeRate: number;
  // Enables the debug chat assistant widget (dev/staging only)
  debugChatEnabled: boolean;
}

const dataEnv: DataEnv =
  (process.env.NEXT_PUBLIC_DATA_ENV as DataEnv) ?? 'inkMainnet';

const brandName: BrandName = (process.env.NEXT_PUBLIC_BRAND_NAME as BrandName) ?? 'stackd';

const builderIdStr = process.env.NEXT_PUBLIC_BUILDER_ID;

export const baseClientEnv: BaseClientEnv = {
  enableExperimentalFeatures:
    process.env.NEXT_PUBLIC_ENABLE_EXPERIMENTAL_FEATURES === 'true',
  dataEnv,
  brandName,
  buildId: process.env.NEXT_PUBLIC_BUILD_ID ?? 'dev',
  builderId: builderIdStr ? parseInt(builderIdStr, 10) : undefined,
  builderFeeRate: parseInt(process.env.NEXT_PUBLIC_BUILDER_FEE_RATE ?? '0', 10),
  debugChatEnabled: process.env.NEXT_PUBLIC_DEBUG_CHAT_ENABLED === 'true',
};
